import React from 'react';


function IndependenceStatement() {
  return (
    <>

      <div className="max-w-4xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-8 border-b border-gray-200 pb-4">Independence Statement</h1>

        <div className="space-y-12 text-gray-800">
          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">1. Organizational Independence</h2>
            <p className="leading-relaxed">
              The AI Accountability Standards Council (AASC) operates as an autonomous standards body. We are not a subsidiary of any agency holding company, software conglomerate, or cloud service provider. This structural independence is fundamental to our mission of objective oversight.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">2. Technical Independence</h2>
            <p className="leading-relaxed">
              AASC standards are defined based on operational necessity and risk management principles. We do not tailor standards to favor specific proprietary platforms or models. Our frameworks are interoperable across the AI ecosystem.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">3. Financial Independence</h2>
            <p className="leading-relaxed">
              The Council maintains financial separation from the entities it standardizes. We do not accept equity positions in declared organizations. We do not accept funding from foundation model providers for standards development.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#102A43] mb-4 uppercase tracking-wide">4. Regulatory Independence</h2>
            <p className="leading-relaxed">
              While we monitor global regulatory developments (such as the EU AI Act), the AASC remains a private sector standards body. We are not an arm of any government. Our standards complement, but do not replace, statutory regulation.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}

export default IndependenceStatement;